import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  CommissionRewardInfo,
  DefaultReferralCode,
  ReferralInfo,
  ReferralRewardInfo,
  RegisterNewReferral,
  RewardNotifications,
} from '../interfaces/alliance.interface';
import { ResponseData } from '../interfaces/response.interface';
import { BaseApi } from './base.api';

@Injectable({
  providedIn: 'root',
})
export class AllianceApi extends BaseApi {
  private get allianceUrl(): string {
    return `${environment.apiUrl}/v1/alliance/alliance`;
  }

  /**
   * 获取默认推荐码
   *
   * @returns 默认推荐码
   */
  getDefaultReferralCode(): Observable<DefaultReferralCode> {
    return this.get<ResponseData<DefaultReferralCode>>(`${this.allianceUrl}/getdefaultreferralcode`).pipe(
      map(x => x?.data || null)
    );
  }

  /**
   * 获取推荐信息
   *
   * @returns 推荐信息
   */
  getReferralInfo(): Observable<ReferralInfo> {
    return this.get<ResponseData<ReferralInfo>>(`${this.allianceUrl}/getreferralinfo`).pipe(map(x => x?.data || null));
  }

  /**
   * 获取VIP奖励信息
   *
   * @returns VIP奖励信息
   */
  getReferralRewardInfo(): Observable<ReferralRewardInfo[]> {
    return this.get<ResponseData<ReferralRewardInfo[]>>(`${this.allianceUrl}/getreferralrewardinfo`).pipe(
      map(x => x?.data || null)
    );
  }

  /**
   * 获取推荐奖励推送信息
   *
   * @returns 推荐奖励推送信息
   */
  getRewardNotifications(): Observable<RewardNotifications> {
    return this.get<ResponseData<RewardNotifications>>(`${this.allianceUrl}/getrewardnotifications`).pipe(
      map(x => x?.data || null)
    );
  }

  /**
   * 获取佣金奖励列表
   *
   * @returns 佣金奖励列表
   */
  getCommissionRewardInfo(): Observable<CommissionRewardInfo[]> {
    return this.get<ResponseData<CommissionRewardInfo[]>>(`${this.allianceUrl}/getcommissionrewardinfo`).pipe(
      map(x => x?.data || null)
    );
  }

  /**
   * 获取是否显示左侧菜单填写推荐Id
   *
   * @returns 是否显示左侧菜单填写推荐Id
   */
  getCanBindReferralId(): Observable<boolean> {
    return this.get<ResponseData<boolean>>(`${this.allianceUrl}/canbind`).pipe(map(x => x?.data || false));
  }

  /**
   * 新好友注册创建推荐关系
   *
   * @param referralCode 推荐码
   * @param uid uid
   * @returns 推荐信息
   */
  registerNewReferral(referralCode: string, uid: string): Observable<ResponseData<RegisterNewReferral>> {
    return this.post<ResponseData<RegisterNewReferral>>(`${this.allianceUrl}/registernewreferral`, {
      referralCode,
      uid,
    });
  }
}
